import { render, staticRenderFns } from "./SwipeCardRecord.vue?vue&type=template&id=00a6e53a&scoped=true"
import script from "./SwipeCardRecord.vue?vue&type=script&lang=js"
export * from "./SwipeCardRecord.vue?vue&type=script&lang=js"
import style0 from "./SwipeCardRecord.vue?vue&type=style&index=0&id=00a6e53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a6e53a",
  null
  
)

export default component.exports